@if (sharedData(); as sharedData) {
<mod-client-packages [inputData]="sharedData"></mod-client-packages>
}
